import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

interface NoLinkFoundDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

export const NoLinkFoundDialog = ({
  isOpen,
  onClose,
  onConfirm,
}: NoLinkFoundDialogProps) => {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>No Link Found</DialogTitle>
      <DialogContent>
        <DialogContentText>
          If you can&apos;t link this supplementary report to an original
          report, it will be converted to a standalone report.
        </DialogContentText>
        <DialogContentText>
          <br />
          <b>Are you sure you want to proceed?</b>
        </DialogContentText>
      </DialogContent>
      <DialogActions
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "16px",
        }}
      >
        <Button onClick={onClose} color="secondary" variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={() => {
            onConfirm().then(() => {
              onClose();
            });
          }}
          color="primary"
          variant="contained"
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};
